(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5355],{

/***/ 5355:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "BuyInBulkGeneralSlider": function() { return /* binding */ BuyInBulkGeneralSlider; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _styles_components_buy_in_bulk_general_slider_index_module_scss__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(7775);
/* harmony import */ var _styles_components_buy_in_bulk_general_slider_index_module_scss__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_styles_components_buy_in_bulk_general_slider_index_module_scss__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var swiper_react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(719);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var swiper__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(8116);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(7294);
/* harmony import */ var framer_motion__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(7037);
/* harmony import */ var swiper_css__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(1082);
/* harmony import */ var swiper_css__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(swiper_css__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var swiper_css_pagination__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(6797);
/* harmony import */ var swiper_css_pagination__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(swiper_css_pagination__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var swiper_css_effect_fade__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(3029);
/* harmony import */ var swiper_css_effect_fade__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(swiper_css_effect_fade__WEBPACK_IMPORTED_MODULE_7__);







// Import Swiper styles



const BuyInBulkGeneralSlider = (props)=>{
    // Animation of image when scrolling and in view
    const ref = (0,react__WEBPACK_IMPORTED_MODULE_4__.useRef)(null);
    const isInView = (0,framer_motion__WEBPACK_IMPORTED_MODULE_8__/* .useInView */ .Y)(ref, {
        once: false
    });
    // Configuration for swiper
    const swiperConfig = {
        modules: [
            swiper__WEBPACK_IMPORTED_MODULE_3__/* .Navigation */ .W_,
            swiper__WEBPACK_IMPORTED_MODULE_3__/* .Pagination */ .tl,
            swiper__WEBPACK_IMPORTED_MODULE_3__/* .Scrollbar */ .LW,
            swiper__WEBPACK_IMPORTED_MODULE_3__/* .A11y */ .s5,
            swiper__WEBPACK_IMPORTED_MODULE_3__/* .EffectFade */ .xW
        ],
        spaceBetween: 0,
        centeredSlides: true,
        centeredSlidesBounds: true,
        initialSlide: 0,
        loop: true,
        fade: "true",
        pagination: {
            el: ".swiper-pagination",
            clickable: true
        },
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev"
        },
        breakpoints: {
            320: {
                slidesPerView: 1,
                spaceBetween: 70
            },
            481: {
                slidesPerView: 2,
                spaceBetween: 0
            },
            768: {
                slidesPerView: 3,
                spaceBetween: 70
            },
            1025: {
                slidesPerView: 3.85,
                spaceBetween: 0
            },
            1201: {
                slidesPerView: 3.85,
                spaceBetween: 0
            }
        }
    };
    /**
     * Variables are used for the class for the images to animate it, the value are changed based on the state of the image
     */ const animateImages = ()=>{
        setLeftImgClassList1("img_left img_left_rotate_1 img_left_animate ");
        setRightImgClassList1("img_right img_right_rotate_1 img_right_animate");
        setLeftImgClassList2("img_left img_left_rotate_1");
        setRightImgClassList2("img_right img_left_rotate_1");
        setTimeout(()=>{
            setLeftImgClassList1("img_left");
            setRightImgClassList1("img_right");
            setLeftImgClassList2("img_left img_left_rotate_1");
            setRightImgClassList2("img_right img_right_rotate_1");
        }, 1000);
    };
    // Animation Image State Management and classes
    const [currentImages, setCurrentImages] = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)({
        leftImageUrl: "",
        rightImageUrl: ""
    });
    const [rightImgClassList1, setRightImgClassList1] = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)("img_right img_right_rotate_1");
    const [rightImgClassList2, setRightImgClassList2] = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)("img_right");
    const [leftImgClassList1, setLeftImgClassList1] = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)("img_left img_left_rotate_1");
    const [leftImgClassList2, setLeftImgClassList2] = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)("img_left");
    /***
     * This section contains code of the honey items in horizontal scroll.
     * Used swiper for horizontal infinite scroll.
     * It contains 3 title, and the css are inherited from root style and for inner image ,title and line
     * the style is defined in the separate file of this component.
     */ // @ts-ignore
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("section", {
        className: "product-container ".concat((_styles_components_buy_in_bulk_general_slider_index_module_scss__WEBPACK_IMPORTED_MODULE_9___default().slider_list)),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "titles",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                        className: "title-bold",
                        children: props.title
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        className: "title-normal",
                        dangerouslySetInnerHTML: {
                            __html: props.type
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(swiper_react__WEBPACK_IMPORTED_MODULE_1__/* .Swiper */ .tq, {
                ...swiperConfig,
                slidesPerView: "auto",
                ref: ref,
                onSlideChange: (swipe)=>{},
                children: [
                    props.ItemList.map((item, index)=>{
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(swiper_react__WEBPACK_IMPORTED_MODULE_1__/* .SwiperSlide */ .o5, {
                            className: "".concat((_styles_components_buy_in_bulk_general_slider_index_module_scss__WEBPACK_IMPORTED_MODULE_9___default().honey_item)),
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                                href: "/products/detail/" + props.itemType + "-bulk/" + item.Shopify_Link,
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                        className: "".concat(isInView ? "slide-up-animation-active" : "slide-up-animation"),
                                        loading: "lazy",
                                        src: item.Image_Buy_In_Bulk.url,
                                        alt: item.Image_Buy_In_Bulk.alternativeText
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: (_styles_components_buy_in_bulk_general_slider_index_module_scss__WEBPACK_IMPORTED_MODULE_9___default().bar_line)
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                suppressHydrationWarning: true,
                                                children: item.Title_Buy_In_Bulk
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                className: (_styles_components_buy_in_bulk_general_slider_index_module_scss__WEBPACK_IMPORTED_MODULE_9___default().vertical_line)
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                                children: [
                                                    item.Buy_In_Bulk_Pcs,
                                                    " PCS"
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        }, props.itemType + "-" + index);
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "swiper-button-prev ".concat((_styles_components_buy_in_bulk_general_slider_index_module_scss__WEBPACK_IMPORTED_MODULE_9___default().swiper_button_prev_next)),
                        tabIndex: 0,
                        role: "button",
                        "aria-label": "Previous slide",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                            src: "/assets/images/decorations/extra/left_arrow.png",
                            alt: "previous"
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "swiper-button-next ".concat((_styles_components_buy_in_bulk_general_slider_index_module_scss__WEBPACK_IMPORTED_MODULE_9___default().swiper_button_prev_next)),
                        tabIndex: 0,
                        role: "button",
                        "aria-label": "Next slide",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                            src: "/assets/images/decorations/extra/right_arrow.png",
                            alt: "next"
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "swiper-pagination",
                        children: props.ItemList.map((_, index)=>{
                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                className: "swiper-pagination-bullet",
                                tabIndex: 0,
                                role: "button",
                                "aria-label": "Go to slide ".concat(index)
                            }, "dot-" + props.itemType + "-" + index);
                        })
                    })
                ]
            })
        ]
    });
};


/***/ }),

/***/ 7775:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"primary":"#1d1f22","secondary":"#ece8e1","title-secondary":"#575759","body":"#f4f3f0","text-color-white":"#f9f7f2","red":"#cd5f5f","golden":"#c2ab7a","gray":"#938985","slider_list":"general-slider_slider_list__97d9h","honey_item":"general-slider_honey_item__774aP","bar_line":"general-slider_bar_line__I_ozV","vertical_line":"general-slider_vertical_line__ZCh3o","swiper_button_prev_next":"general-slider_swiper_button_prev_next__2BBaY","about-image-in":"general-slider_about-image-in__Bvu5O","fade-in-honeycomb":"general-slider_fade-in-honeycomb__4wd_8","dot-falling":"general-slider_dot-falling__h4hvQ","dot-falling-before":"general-slider_dot-falling-before__8ZNB_","dot-falling-after":"general-slider_dot-falling-after__XwBK9"};

/***/ }),

/***/ 3029:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 6797:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ })

}]);